/**
 * @generated SignedSource<<00877c37c7b169476c7c8283a9b652eb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type APIKeysRevokeMutation$variables = {
  id: string;
};
export type APIKeysRevokeMutation$data = {
  readonly apiKeys: {
    readonly revoke: {
      readonly ok: boolean | null;
    } | null;
  } | null;
};
export type APIKeysRevokeMutation = {
  response: APIKeysRevokeMutation$data;
  variables: APIKeysRevokeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "APIKeyMutation",
    "kind": "LinkedField",
    "name": "apiKeys",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "concreteType": "RevokeAPIKeyMutation",
        "kind": "LinkedField",
        "name": "revoke",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ok",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "APIKeysRevokeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "APIKeysRevokeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7f626eb31d8f844d161b85bcada8b185",
    "id": null,
    "metadata": {},
    "name": "APIKeysRevokeMutation",
    "operationKind": "mutation",
    "text": "mutation APIKeysRevokeMutation(\n  $id: ID!\n) {\n  apiKeys {\n    revoke(id: $id) {\n      ok\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e1c678f88448c1e62abe1ec47ea51041";

export default node;
